<template>
  <div class=" ">
    <slot />
    <div class="flex justify-center space-x-2 -mt-1" v-if="getISActive">
      <button
        @click="logout"
        class="border border-color text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.5vw] text-[12px] truncate"
      >
        تسجيل خروج
      </button>
    </div>
    <div class="flex justify-center space-x-2 -mt-1" v-else>
      <button
        @click="subscribe"
        class="sub-btn-bg text-white text-center rounded-md md:px-8 px-4 py-1 md:text-[1.5vw] text-[12px] truncate"
      >
        اشترك الان
      </button>
      <router-link to="/login">
        <button
          class="border border-color text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.5vw] text-[12px] truncate"
        >
          تسجيل دخول
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import { mapActions, mapState } from "pinia";
export default {
  components: {
    // SpinnerView,
  },
  data() {
    return {
      user: false,
      isActive: false,
      isDone: false,
      loading: false,
    };
  },
  async mounted() {
    await this.chechIsDoneAction();
    await this.checkIsActiveAction();
  },
  watch: {
    // whenever question changes, this function will run
    // eslint-disable-next-line
    getISActive(newValue, oldValue) {},
  },
  computed: {
    ...mapState(useAuthStore, ["getISActive"]),
  },
  methods: {
    async chechIsDoneAction() {
      return (this.isDone = localStorage.getItem("isDone"));
    },
    async checkIsActiveAction() {
      return (this.isActive = localStorage.getItem("isActive"));
    },
    ...mapActions(useAuthStore, ["unsubscribe", "subscribeAction", "logOut"]),
    async subscribe() {
      this.loading = true;

      await this.subscribeAction();
      this.loading = false;
    },
    async cancelSubscription() {
      this.loading = true;
      await this.unsubscribe().then((response) => {
        this.redirectUser(response);
      });
      this.loading = false;
    },
    redirectUser(response) {
      {
        if (response.data.status == false && response.data.isActive == false) {
          this.isActive = false;
          return this.$router.push({ name: "home" });
        }
      }
    },
    logout() {
      this.logOut();
      this.$router.push({ name: "home" });
    },
  }, //end of methods
};
</script>

<style></style>
